const routerPass = { // key为目标路径 value为初始路径
    MaintenancePublishingNode: [],//检查维保发布页
    // MaintenancePublishHome: ["MaintenancePublishingNode", "SelectJobContent"],//检查维保页
    MaintenanceHomePage:["MaintenancereadonlyHome",'MaintenanceHistoryPage','MaintenanceFileDownload','MaintenanceGenerateDocument','draftMaintenanceHome'],
    DailycheckHomePage:["DailycheckreadonlyHome",'DailycheckHistoryPage','DailycheckFileDownload','DailycheckGenerateDocument'],
    InstallationHomePage:["InstallationreadonlyHome",'InstallationHistoryPage','InstallationFileDownload','InstallationGenerateDocument'],
    SiteHomePage:["SitereadonlyHome",'SiteHistoryPage','SiteFileDownload','SiteGenerateDocument'],
    Detection:['Nextconfirmation','RecordDetailsOnly','ReadOnly','HistoryList','GenerateDocument',
                'FileDownload','PublishHome','draftDetai','RecheckReleasePreview',
            ],
    inspectionHome:[
        'historyPage'
    ],
    PatrolHome:['patrollssue','patroldownload','patrolcreate','patrolcompile','patrolpersonnelOperation','indexOnly'],
    patrolcompile:["patrolHome","patroldevices"],
    // evaindexOnly:['evaHome',"equipmentscore"],
    EvaHome:['evalssue','evadownload','evacreate','evacompile','evapersonnelOperation','evaindexOnly'],
    evacompile:['EvaHome','evadevices',"equipmentscore"],

}
export const mixin = {
    beforeRouteLeave(to, from, next) {
        getScroll(this,from.name)  //路由离开时记录滚动条位置
        if (routerPass[to.name]) {
            if (this.$vnode && this.$vnode.parent && this.$vnode.parent.componentInstance) {
                if (routerPass[to.name].length != 0) {
                    var i = routerPass[to.name].indexOf(from.name)
                    if (i < 0) {
                        //$vnode清除缓存
                        this.$vnode.parent.componentInstance.cache = {};
                        this.$vnode.parent.componentInstance.keys = [];
                    }
                }
            }
        }
        next();
    },
    beforeRouteEnter(to, from, next) {
        next( vm => {
            setTimeout(() => {
                setScroll(vm,to.name)  //路由进入时设置滚动条位置
            },50)
        })
    },


}

/*
* 滚动条位置记录
* 配置规则
* 所有需要记录位置的组件使用ref名为scroll
* 所有需要记录位置的组件为子组件时 需要给子组件传ref 名称随意
* */
function getScroll(vm,routerName,name = '') {
    if(vm.$refs) {
        if(vm.$refs['scroll']) {
            vm.$store.commit('SET_SCROLL_POSITION',{
                key: routerName + name,
                value: vm.$refs['scroll'].scrollTop
            })
        }
        if(Object.keys(vm.$refs).length > 0) {
            Object.keys(vm.$refs).forEach(v => {
                console.log();
                if(v.indexOf("scroll") >= 0 ) {
                    vm.$store.commit('SET_SCROLL_POSITION',{
                        key: routerName + v,
                        value: vm.$refs[v].scrollTop
                    })
                } else {
                    getScroll(vm.$refs[v],routerName,name + v)
                }
            })
        }
    }
}
function setScroll(vm,routerName,name = ''){
    if(vm.$refs) {
        if(vm.$refs['scroll']) {
            vm.$refs['scroll'].scrollTop = vm.$store.state.scrollPosition[routerName + name]
        }
        if(Object.keys(vm.$refs).length > 0) {
            Object.keys(vm.$refs).forEach(v => {
                if(v.indexOf("scroll") >= 0 ) {
                    vm.$refs[v].scrollTop = vm.$store.state.scrollPosition[routerName + v]
                } else {
                    setScroll(vm.$refs[v],routerName,name + v)
                }
            })

        }
    }
}
